interface StaticVariantConfig {
  color: string
  price: number
  images: string[]
  photos?: string[]
  photosZoom?: string[]
}

interface StaticCollectionConfig {
  slug: string
  name: string
  productTitle: string
  productSlug: string
  variants: StaticVariantConfig[]
}

interface StaticCollectionFallbackContext {
  lookupPayloads?: Array<{ endpoint: string, payload: any }>
  routes?: string[]
  rawLookup?: any
}

const STATIC_COLLECTIONS: Record<string, StaticCollectionConfig> = {
  align: {
    slug: 'align',
    name: 'ALIGN',
    productTitle: 'ALIGN 110 Ankle Boot',
    productSlug: 'align-110-ankle-boot',
    variants: [
      {
        color: 'Black',
        price: 680,
        images: [
          '/product/ankle-boots/_/kendrick-ankle-boots-black-1.jpg',
          '/product/ankle-boots/_/kendrick-ankle-boots-black-2.jpg',
          '/product/ankle-boots/_/kendrick-ankle-boots-black-3.jpg'
        ],
        photos: [
          '/product/ankle-boots/looks/kendrick-ankle-boots-black-21.jpg',
          '/product/ankle-boots/looks/kendrick-ankle-boots-black-19.jpg'
        ],
        photosZoom: [
          '/product/ankle-boots/looks/kendrick-ankle-boots-black-19z.jpg',
          '/product/ankle-boots/looks/kendrick-ankle-boots-black-7z.jpg'
        ]
      },
      {
        color: 'Beige',
        price: 680,
        images: [
          '/product/ankle-boots/_/kendrick-ankle-boots-beige-1.jpg',
          '/product/ankle-boots/_/kendrick-ankle-boots-beige-2.jpg',
          '/product/ankle-boots/_/kendrick-ankle-boots-beige-3.jpg'
        ],
        photos: [
          '/product/ankle-boots/looks/kendrick-ankle-boots-beige-1.jpg'
        ],
        photosZoom: [
          '/product/ankle-boots/looks/kendrick-ankle-boots-beige-1z.jpg'
        ]
      },
      {
        color: 'Red',
        price: 680,
        images: [
          '/product/ankle-boots/_/kendrick-ankle-boots-red-1.jpg',
          '/product/ankle-boots/_/kendrick-ankle-boots-red-2.jpg',
          '/product/ankle-boots/_/kendrick-ankle-boots-red-3.jpg'
        ],
        photos: [
          '/product/ankle-boots/looks/kendrick-ankle-boots-red-1.jpg',
          '/product/ankle-boots/looks/kendrick-ankle-boots-red-2.jpg',
          '/product/ankle-boots/looks/kendrick-ankle-boots-red-3.jpg'
        ],
        photosZoom: [
          '/product/ankle-boots/looks/kendrick-ankle-boots-red-1z.jpg',
          '/product/ankle-boots/looks/kendrick-ankle-boots-red-2z.jpg',
          '/product/ankle-boots/looks/kendrick-ankle-boots-red-3z.jpg'
        ]
      },
      {
        color: 'Yellow',
        price: 680,
        images: [
          '/product/ankle-boots/_/kendrick-ankle-boots-yellow-1.jpg',
          '/product/ankle-boots/_/kendrick-ankle-boots-yellow-2.jpg',
          '/product/ankle-boots/_/kendrick-ankle-boots-yellow-3.jpg'
        ],
        photos: [
          '/product/ankle-boots/looks/kendrick-ankle-boots-yellow-5.jpg',
          '/product/ankle-boots/looks/kendrick-ankle-boots-yellow-6.jpg',
          '/product/ankle-boots/looks/kendrick-ankle-boots-yellow-4.jpg'
        ],
        photosZoom: [
          '/product/ankle-boots/looks/kendrick-ankle-boots-yellow-5z.jpg',
          '/product/ankle-boots/looks/kendrick-ankle-boots-yellow-6z.jpg',
          '/product/ankle-boots/looks/kendrick-ankle-boots-yellow-4z.jpg'
        ]
      }
    ]
  },
  axis: {
    slug: 'axis',
    name: 'AXIS',
    productTitle: 'AXIS 110 Boot',
    productSlug: 'axis-110-boot',
    variants: [
      {
        color: 'Black',
        price: 980,
        images: [
          '/product/boots/kendrick-boots-black-1_.jpg',
          '/product/boots/kendrick-boots-black-2.jpg',
          '/product/boots/kendrick-boots-black-3.jpg'
        ],
        photos: [
          '/product/boots/looks/kendrick-boots-black-1.jpg',
          '/product/boots/looks/kendrick-boots-black-2.jpg',
          '/product/boots/looks/kendrick-boots-black-3.jpg'
        ],
        photosZoom: [
          '/product/boots/looks/kendrick-boots-black-1z.jpg',
          '/product/boots/looks/kendrick-boots-black-2z.jpg',
          '/product/boots/looks/kendrick-boots-black-3z.jpg'
        ]
      },
      {
        color: 'Beige',
        price: 980,
        images: [
          '/product/boots/kendrick-boots-beige-1.jpg'
        ]
      },
      {
        color: 'Red',
        price: 980,
        images: [
          '/product/boots/kendrick-boots-red-1.jpg'
        ]
      },
      {
        color: 'Yellow',
        price: 980,
        images: [
          '/product/boots/kendrick-boots-yellow-1.jpg'
        ]
      }
    ]
  },
  edge: {
    slug: 'edge',
    name: 'EDGE',
    productTitle: 'EDGE 110 Pump',
    productSlug: 'edge-110-pump',
    variants: [
      {
        color: 'Black',
        price: 450,
        images: [
          '/product/pumps/_/kendrick-pumps-black-1.jpg',
          '/product/pumps/_/kendrick-pumps-black-2.jpg',
          '/product/pumps/_/kendrick-pumps-black-3.jpg'
        ],
        photos: [
          '/product/pumps/looks/kendrick-pumps-black-1.jpg',
          '/product/pumps/looks/kendrick-pumps-black-2.jpg'
        ],
        photosZoom: [
          '/product/pumps/looks/kendrick-pumps-black-1z.jpg',
          '/product/pumps/looks/kendrick-pumps-black-2z.jpg'
        ]
      },
      {
        color: 'Beige',
        price: 450,
        images: [
          '/product/pumps/_/kendrick-pumps-beige-1.jpg',
          '/product/pumps/_/kendrick-pumps-beige-2.jpg',
          '/product/pumps/_/kendrick-pumps-beige-3.jpg'
        ],
        photos: [
          '/product/pumps/looks/kendrick-pumps-beige-1.jpg',
          '/product/pumps/looks/kendrick-pumps-beige-2.jpg',
          '/product/pumps/looks/kendrick-pumps-beige-3.jpg'
        ],
        photosZoom: [
          '/product/pumps/looks/kendrick-pumps-beige-1z.jpg',
          '/product/pumps/looks/kendrick-pumps-beige-2z.jpg',
          '/product/pumps/looks/kendrick-pumps-beige-3z.jpg'
        ]
      },
      {
        color: 'Red',
        price: 450,
        images: [
          '/product/pumps/_/kendrick-pumps-red-1.jpg',
          '/product/pumps/_/kendrick-pumps-red-2.jpg',
          '/product/pumps/_/kendrick-pumps-red-3.jpg'
        ],
        photos: [
          '/product/pumps/looks/kendrick-pumps-red-1.jpg',
          '/product/pumps/looks/kendrick-pumps-red-2.jpg',
          '/product/pumps/looks/kendrick-pumps-red-3.jpg'
        ],
        photosZoom: [
          '/product/pumps/looks/kendrick-pumps-red-1z.jpg',
          '/product/pumps/looks/kendrick-pumps-red-2z.jpg',
          '/product/pumps/looks/kendrick-pumps-red-3z.jpg'
        ]
      },
      {
        color: 'Yellow',
        price: 450,
        images: [
          '/product/pumps/_/kendrick-pumps-yellow-1.jpg',
          '/product/pumps/_/kendrick-pumps-yellow-2.jpg',
          '/product/pumps/_/kendrick-pumps-yellow-3.jpg'
        ],
        photos: [
          '/product/pumps/looks/kendrick-pumps-yellow-2.jpg',
          '/product/pumps/looks/kendrick-pumps-yellow-3.jpg'
        ]
      }
    ]
  },
  poise: {
    slug: 'poise',
    name: 'POISE',
    productTitle: 'POISE 110 Sandal',
    productSlug: 'poise-110-sandal',
    variants: [
      {
        color: 'Black',
        price: 490,
        images: [
          '/product/sandals/_/kendrick-sandals-black-1.jpg',
          '/product/sandals/_/kendrick-sandals-black-2.jpg',
          '/product/sandals/_/kendrick-sandals-black-3.jpg'
        ]
      },
      {
        color: 'Beige',
        price: 490,
        images: [
          '/product/sandals/_/kendrick-sandals-beige-1.jpg',
          '/product/sandals/_/kendrick-sandals-beige-2.jpg',
          '/product/sandals/_/kendrick-sandals-beige-3.jpg'
        ],
        photos: [
          '/product/sandals/looks/kendrick-sandals-beige-1.jpg'
        ],
        photosZoom: [
          '/product/sandals/looks/kendrick-sandals-beige-1z.jpg'
        ]
      },
      {
        color: 'Red',
        price: 490,
        images: [
          '/product/sandals/_/kendrick-sandals-red-1.jpg',
          '/product/sandals/_/kendrick-sandals-red-2.jpg',
          '/product/sandals/_/kendrick-sandals-red-3.jpg'
        ],
        photos: [
          '/product/sandals/looks/kendrick-sandals-red-1.jpg'
        ],
        photosZoom: [
          '/product/sandals/looks/kendrick-sandals-red-1z.jpg'
        ]
      },
      {
        color: 'Yellow',
        price: 490,
        images: [
          '/product/sandals/_/kendrick-sandals-yellow-1.jpg',
          '/product/sandals/_/kendrick-sandals-yellow-2.jpg',
          '/product/sandals/_/kendrick-sandals-yellow-3.jpg'
        ]
      }
    ]
  }
}

function buildStaticCollectionPayload(spaceId: string, config: StaticCollectionConfig) {
  const product = {
    id: `static-product-${config.slug}`,
    title: config.productTitle,
    slug: config.productSlug,
    price_amount: config.variants[0]?.price || 0,
    images: config.variants.flatMap(variant => variant.images).filter(Boolean),
    variants: config.variants.map((variant) => ({
      id: `static-variant-${config.slug}-${variant.color.toLowerCase()}`,
      option1: variant.color,
      price_amount: variant.price,
      images: variant.images,
      photos: variant.photos || [],
      photos_zoom: variant.photosZoom || []
    }))
  }

  return {
    id: `static-collection-${config.slug}`,
    slug: config.slug,
    name: config.name,
    slogan: '',
    description: '',
    space_id: spaceId,
    items: [
      {
        id: `static-item-${config.slug}`,
        products: product
      }
    ],
    collection: {
      id: `static-collection-${config.slug}`,
      slug: config.slug,
      name: config.name,
      slogan: '',
      description: '',
      space_id: spaceId
    }
  }
}

export function getStaticAssetsKitCollectionResponse(
  spaceId: string,
  slug: string,
  context: StaticCollectionFallbackContext = {}
) {
  const config = STATIC_COLLECTIONS[slug]
  if (!config) return null

  return {
    collection: buildStaticCollectionPayload(spaceId, config),
    rawLookup: context.rawLookup || null,
    lookupPayloads: context.lookupPayloads || [],
    routes: context.routes || [],
    error: null,
    source: 'static'
  }
}
